<div class="relative text-platform px-3">
  <div class="h-32 lg:h-40"></div>
  <div class="font-bold text-4xl">Impressum</div>
</div>
